import { beads } from '../beads.js';
import { settings } from '../settings.js';
import { modes } from '../modes.js';
import { tri } from '../patterns/triangle.js'; // needs to be here for webpack
import { star } from '../patterns/star.js'; // needs to be here for webpack

export const doBeading = {};

const getStartingPosition = ({bead}) => settings.pattern.getBeadingModeStartingPosition === undefined ?
    [bead.row, bead.column]:
    settings.pattern.getBeadingModeStartingPosition({bead});

const getStartingOffset = ({bead}) => {
    if (settings.pattern.rotateCamera) {
        return beads.rowOffset[bead.row];
    }
    if (settings.pattern.name === 'triangle') {
        return 1;
    }
};

doBeading.start = bead => {
    [doBeading.row, doBeading.column] = getStartingPosition({bead});
    doBeading.isHorizontal = settings.pattern.name === 'loom' ?
        false :
        !settings.pattern.rotateCamera;

    doBeading.offset = getStartingOffset({bead});
    b3.store.mySet('showingPanel', 'beading');

    modes.start('beading');
    beads.refreshCanvas();
};

doBeading.shouldHighlight = bead => {

    if (settings.pattern.doBeadingKey) {
        return doBeading[settings.pattern.doBeadingKey](bead);
    }

    let result = doBeading.isHorizontal ?
        bead.row === doBeading.row:
        bead.column === doBeading.column;

    if (settings.pattern.rotateCamera && !doBeading.isHorizontal) {
        if (beads.rowOffset[bead.row] !== doBeading.offset) {
            result = false;
        }
    }

    return result;
};

doBeading.medallion = bead => {
    let result = bead.circleAddress.r === doBeading.row;

    return result;
};

doBeading.triangle = bead => {
    let result = bead.tri.column === doBeading.row;

    if (bead.tri.row % 2 === doBeading.offset) {
        result = false;
    }

    return result;
};

doBeading.square = bead => {
    let result = bead.star.row === doBeading.row;

    return result;
};

doBeading.advanceSquare = increment => {
    doBeading.row += increment;
    if (doBeading.row === 0 || (doBeading.row > settings.rows)) {
        modes.start('draw');
    }
    beads.refreshCanvas();
};

doBeading.advanceTriangle = increment => {
    doBeading.offset -= increment;
    if (doBeading.offset === 2) {
        doBeading.offset = 0;
        doBeading.row++;
    } else if (doBeading.offset === -1) {
        doBeading.offset = 1;
        doBeading.row--;
    }
    beads.refreshCanvas();
    if (doBeading.row === 0 && doBeading.offset === 1) {
        modes.start('draw');
    }
    if (doBeading.row > settings.rows) modes.start('draw');
    return;
};

doBeading.next = (reverse=false) => {

    let increment = reverse ? -1 : 1;

    if (settings.pattern.advanceBeadingKey) {
        doBeading[settings.pattern.advanceBeadingKey](increment);
        return;
    }
    if (settings.pattern.name === 'triangle') {
        doBeading.advanceTriangle(increment);
        return;
    }

    if (doBeading.isHorizontal) {
        doBeading.row += increment;
    } else {
        if (settings.pattern.rotateCamera) {
            doBeading.offset -= increment;
            if (doBeading.offset === -1) {
                doBeading.offset = 1;
                doBeading.column++;
            } else if (doBeading.offset === 2) {
                doBeading.offset = 0;
                doBeading.column--;
            }
        } else {
            doBeading.column += increment;
        }
    }

    let withinBounds = true;

    if (doBeading.row < 0) withinBounds = false;
    if (doBeading.row >= settings.rows) withinBounds = false;

    if (settings.pattern.name !== 'medallion') {
        if (doBeading.column < 0) withinBounds = false;
        if (doBeading.column >= settings.columns) withinBounds = false;
    }

    withinBounds ?
        beads.refreshCanvas():
        modes.start('draw');
};

doBeading.changeOrientation = () => {
    if (settings.pattern.doBeadingKey) return;
    doBeading.isHorizontal = !doBeading.isHorizontal;
    beads.refreshCanvas();
};
